import React from "react";
import StrategicPartnersShowcase from "../Home/StrategicPartnersShowcase.jsx";

const PartnersPage = () => <StrategicPartnersShowcase />;

export default PartnersPage;
